import { render, staticRenderFns } from "./UserActionInfoSetPlayerLevel.vue?vue&type=template&id=4854fd6f&"
import script from "./UserActionInfoSetPlayerLevel.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoSetPlayerLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports